module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('blockquote', {
    attrs: {
      "epub:type": "epigraph",
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "epi_epiv_only"
  }, [_c('span', {
    attrs: {
      "aria-label": "vii",
      "id": "pg_vii",
      "role": "doc-pagebreak"
    }
  }, [_c('i', [_vm._v("If something exists somewhere, it will exist everywhere.")])])]), _vm._v(" "), _c('p', {
    staticClass: "epi_episrc"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("—CZESŁAW MIŁOSZ")])]), _vm._v(" "), _c('p', {
    staticClass: "epi_epiv_only"
  }, [_c('i', [_vm._v("Love came … after the kill.")])]), _vm._v(" "), _c('p', {
    staticClass: "epi_episrc"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("—ANNE SEXTON")])]), _vm._v(" "), _c('p', {
    staticClass: "epi_epiv_first"
  }, [_c('i', [_vm._v("I wonder if there is")])]), _vm._v(" "), _c('p', {
    staticClass: "epi_epiv_middle"
  }, [_c('i', [_vm._v("any operation")])]), _vm._v(" "), _c('p', {
    staticClass: "epi_epiv_last"
  }, [_c('i', [_vm._v("that removes memories.")])]), _vm._v(" "), _c('p', {
    staticClass: "epi_episrc"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("—SHINOE SHŌDA")])]), _vm._v(" "), _c('p', {
    staticClass: "epi_epiv_middle"
  }, [_c('i', [_vm._v("… and if my body is still the soft part of the mountain")])]), _vm._v(" "), _c('p', {
    staticClass: "epi_epiv_middle"
  }, [_c('i', [_vm._v("I’ll know")])]), _vm._v(" "), _c('p', {
    staticClass: "epi_epiv_middle"
  }, [_c('i', [_vm._v("I am not yet the mountain.")])]), _vm._v(" "), _c('p', {
    staticClass: "epi_episrc"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("—JOSÉ WATANABE")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd661e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 69
// module chunks = 0